var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasMessages)?_c('error',{attrs:{"message-store":_vm.messageStore,"pop-messages":_vm.popMessages,"show-messages":_vm.showMessages,"in-popup":this.inPopup}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }